import { Sankey } from "recharts";
import { Tooltip } from "../ui/tooltip";

export const SankeyCharts = ({
  distributionObj,
  coreMap,
  sourcePropNm,
  gradientConfig,
  gradientId = "",
  linkColor = "",
  width,
  height,
}) => {
  let nodes = [
    { name: sourcePropNm, colorNm: "var(--color-sanky-node0)", nos: 0, hidden: false },
  ];
  let links = [];
  let totalSrcNos = 0;
  Object.entries(distributionObj).forEach(([key, value]) => {
    totalSrcNos = totalSrcNos + value;
    if (value > 0) {
      nodes.push({
        name: coreMap[key].label,
        colorNm: coreMap[key].clrCode,
        nos: value,
        hidden: false,
      });
      links.push({ source: 0, target: links.length + 1, value });
    }
  });

  if(links.length === 1) {
    nodes.push({
      name: "",
      colorNm: "var(--color-primary)",
      nos: 0,
      hidden: true,
    });
    links.push({ source: 0, target: links.length + 1, value: 0.001 });
  }

  nodes = nodes.map((node, i) => {
    return {
      ...node,
      nos: i === 0 ? totalSrcNos : node.nos,
      percNos: ((node.nos / totalSrcNos) * 100).toFixed(2) + "%",
    };
  });

  const data = {
    nodes,
    links,
  };
  console.log(data);
  return (
    <Sankey
      width={width}
      height={height}
      data={data}
      node={<CustomSankeyNode />}
      //   node={{stroke: '#77c878', strokeWidth: 2}}
      nodePadding={30}
      margin={{
        left: 25,
        right: 100,
        top: 0,
        bottom: 20,
      }}
      link={{
        stroke: `${
          gradientId.trim().length ? "url(#" + gradientId + ")" : linkColor
        }`,
      }}
    >
      <Tooltip />
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          {gradientConfig.map((stop, index) => (
            <stop key={index} offset={stop.offset} stopColor={stop.stopColor} />
          ))}
        </linearGradient>
      </defs>
    </Sankey>
  );
};

const CustomSankeyNode = ({
  x,
  y,
  width,
  height,
  index,
  payload,
  containerWidth,
  ...props
}) => {
  // You can access node-specific data from 'payload'
  // 'index' is the index of the node in the data array
  // 'x', 'y', 'width', 'height' are the calculated dimensions and position of the node rectangle

  const nodeColor = payload.colorNm;
  const nodeState = payload.hidden;
  const textAnchor = index === 0 ? "middle" : "start";
  const xCor = index === 0 ? x + width / 2 + 20 : x + width + 10;
  const yCor = index === 0 ? y + height / 1.5 : y + 10;
  if (nodeState) return null;
  return (
    <g>
      {index > 0 ? (
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={nodeColor}
          rx={0}
          ry={0}
        />
      ) : (
        <rect
          x={x}
          y={y}
          width={72}
          height={`calc(100% - ${y + 50}px)`}
          fill={nodeColor}
          rx={4}
          ry={4}
        />
      )}
      <text
        x={xCor}
        y={yCor}
        // dy=".35em"
        textAnchor={textAnchor}
        fill="var(--color-primary)"
        fontSize={12}
        fontWeight="700"
      >
        {index === 0 ? payload.nos : payload.percNos}
      </text>
      {/* Node Label */}
      <text
        x={xCor}
        y={yCor + 10}
        dy=".35em"
        textAnchor={textAnchor}
        fill="var(--color-secondary)"
        fontSize={10}
        fontWeight="400"
      >
        {index === 0 ? payload.name : `${payload.name} (${payload.nos})`}
      </text>
    </g>
  );
};
